<!--
  搜索
  lovi 2020-06-29
-->
<template>
  <div class="w100 childRoute-wrapper" :class="{ commodity: type }">
    <van-nav-bar :fixed="true" left-arrow @click-left="navBarBack">
      <template slot="title">
        <van-search
          v-model="searchVal"
          :placeholder="
            type
              ? $t('life.enterProductSearch')
              : $t('life.enterMerchantCommodity')
          "
        />
      </template>
      <span slot="right" @click="search">{{ $t("common.search") }}</span>
    </van-nav-bar>

    <div class="scroll-wrapper">
      <scroll>
        <template v-if="searchVal == ''">
          <!-- 热门搜索 -->
          <div class="serch-list" v-if="type && hotSearchList.length">
            <div class="title">
              <span>{{ $t("common.hotSearch") }}</span>
            </div>
            <div class="item-list">
              <span
                v-for="(item, index) in hotSearchList"
                :key="index"
                @click="quickSearch(item)"
              >
                {{ item }}
              </span>
            </div>
          </div>
          <!-- 历史搜索 -->
          <div class="serch-list" v-if="historySearchList.length">
            <div class="title">
              <span>{{ $t("common.historySearch") }}</span>
              <van-icon name="delete" @click="cleanHistorySearch" />
            </div>
            <div class="item-list">
              <span
                v-for="(item, index) in historySearchList"
                :key="index"
                @click="quickSearch(item)"
              >
                {{ item }}
              </span>
            </div>
          </div>
        </template>
        <template v-else>
          <template v-if="type">
            <shop-list
              v-for="(item, index) in listData"
              :key="index"
              :data="item"
            />
          </template>
          <template v-else>
            <store-list
              v-for="(item, index) in listData"
              :data="item"
              :key="index"
            />
          </template>
        </template>
      </scroll>
    </div>
  </div>
</template>

<script>
import ShopList from "@/components/life/shopList";
import StoreList from "@/components/life/storeList/storeList";
export default {
  props: ["type", "shopId"],
  components: {
    ShopList,
    StoreList
  },
  data() {
    return {
      searchVal: "",
      hotSearchList: [],
      historySearchList: [],
      listData: [],
      lat: "22.544986",
      lng: "114.064794"
    };
  },
  created() {
    this.hotSearch();
    this.historySearch();
  },
  mounted() {},
  computed: {},
  methods: {
    navBarBack() {
      // 返回事件
      this.$emit("update:searchFlag", false);
    },
    search() {
      if (this.searchVal == "") {
        this.$toast(this.$t("common.enterSearchKeyword"));
        return false;
      }
      if (this.type) {
        this.searchProduct();
      } else {
        this.searchStore();
      }
    },
    quickSearch(data) {
      // 快捷搜索
      this.searchVal = data;
      this.search();
    },
    hotSearch() {
      // 热门搜索
      let vm = this;
      vm.$post("/app/store/hotSearch", {}, { loading: true }).then(res => {
        console.log("hotSearch", res);
        vm.hotSearchList = res.list;
      });
    },
    cleanHistorySearch() {
      // 清空历史记录
      let vm = this;
      vm.$post("/app/store/cleanHistorySearch", {}, { loading: true }).then(
        res => {
          console.log("cleanHistorySearch", res);
          vm.historySearch();
        }
      );
    },
    historySearch() {
      // 历史搜索
      let vm = this;
      vm.$post("/app/store/historySearch", {}, { loading: true }).then(res => {
        console.log("historySearch", res);
        vm.historySearchList = res.list;
      });
    },
    searchProduct() {
      // 商品搜索
      let vm = this;
      let params = {};
      params.shop_id = vm.shopId;
      params.title = vm.searchVal;
      vm.$post("/app/store/searchProduct", params, { loading: true }).then(
        res => {
          console.log("searchProduct", res);
          vm.listData = res.list;
        }
      );
    },
    searchStore() {
      // 商家搜索
      let vm = this;
      let params = {};
      params.title = vm.searchVal;
      params.longitude = vm.lng;
      params.latitude = vm.lat;
      vm.$post("/app/store/searchStore", params, { loading: true }).then(
        res => {
          console.log("searchStore", res);
          vm.listData = res.list;
        }
      );
    }
  },
  watch: {}
  // beforeDestroy: {}
};
</script>

<style lang="less" scoped>
.childRoute-wrapper {
  &.commodity {
    bottom: 50px;
  }
}
.scroll-wrapper {
  /deep/.store-list {
    margin: 10px 10px 0;
    padding: 10px 0;
    border-bottom: 1.1px solid #ececec;
    border-radius: 0;
    &:first-child {
      margin-top: 0;
    }
  }
}
.van-nav-bar {
  /deep/.van-nav-bar__title {
    max-width: 100%;
    .van-search {
      width: calc(100vw - 120px);
      padding: 0;
      .van-cell {
        padding: 3px 8px 3px 0;
      }
    }
  }
}

.serch-list {
  padding: 10px;
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 30px;
    font-size: 14px;
    line-height: 1;
    /deep/.van-icon-delete {
      margin-right: 2px;
      font-size: 16px;
    }
  }
  .item-list {
    display: flex;
    justify-content: flex-start;
    flex-flow: wrap;
    line-height: 1.2;
    span {
      margin: 3px 10px 3px 0;
      padding: 3px 8px;
      color: #666;
      background: #e9e9e9;
      border-radius: 10px;
    }
  }
}
</style>
